"use server";

import { testimonialsService } from "../services/testimonialsService";
import { extractDomain, extractFranchiseeId } from "../utils/domain";

export async function getTestimonialsAction(franchiseeId?: string | null, language?: string | null) {
  try {
    const domain = await extractDomain();
    const testimonials = await testimonialsService.fetchByDomain(domain, franchiseeId, language);
    return {
      success: true,
      data: testimonials,
    };
  } catch (error) {
    console.error("[getTestimonialsAction] Error:", error);
    return {
      success: false,
      data: [],
    };
  }
}
